import $ from "jquery";

const bindToggleFaqs = (element) => {
  const $questions = element.find(".faq__question");

  $questions.off("click");
  $questions.on("click", function () {
    const faq = $(this).parent();
    const isActive = faq.hasClass("active");

    faq
      .parent()
      .children(".faq__item")
      .each(function () {
        hideFaq($(this));
      });

    !isActive && showFaq(faq);
  });
};

const showFaq = (faq) => {
  const question = faq.children(".faq__question");
  const answer = faq.children(".faq__answer");

  faq.addClass("active");
  question.addClass("active");
  answer.slideDown(300, () => answer.addClass("active"));
};

const hideFaq = (faq) => {
  const question = faq.children(".faq__question");
  const answer = faq.children(".faq__answer");

  faq.find(".faq__item").each(function () {
    hideFaq($(this));
  });

  faq.removeClass("active");
  question.removeClass("active");
  answer.removeClass("active");
  answer.slideUp(300);
};

const $faq = $(".faq");

if ($faq.length > 0) {
  bindToggleFaqs($faq);
}
